/**
 * BillingWrapper - Hides billing functionality since it's not implemented yet
 * This component will hide all billing-related UI elements until the billing system is ready
 */
export default function BillingWrapper({ children, enabled = false }) {
  // Return null to hide billing components until billing is implemented
  if (!enabled) {
    return null;
  }

  return <>{children}</>;
}
